import { networkRequest } from "./core";
const API_URL = process.env.REACT_APP_API_BASE_URL;

const getAllUser = async (accessToken) => {
  try {
    const response = await networkRequest.get(`${API_URL}/user/all`, {
      idToken: accessToken,
    });
    return response;
  } catch (error) {
    return await Promise.reject(error);
  }
};

const createUser = async (payload) => {
  try {
    const resp = await networkRequest.post(`${API_URL}/user/create`, {
      ...payload,
    });
    return resp;
  } catch (error) {
    return await Promise.reject(error);
  }
};

const deleteUser = async (id) => {
  try {
    const resp = await networkRequest.delete(`${API_URL}/user/delete/${id}`);
    return resp;
  } catch (error) {
    return await Promise.reject(error);
  }
};

const updateUser = async (payload) => {
  try {
    const resp = await networkRequest.put(`${API_URL}/user/edit`, {
      ...payload,
    });
    return resp;
  } catch (error) {
    return await Promise.reject(error);
  }
};

const getCurrentUser = async (accessToken) => {
  try {
    const response = await networkRequest.get(`${API_URL}/user/currentUser`, {
      idToken: accessToken,
    });
    return response;
  } catch (error) {
    return await Promise.reject(error);
  }
};

const getCurrentUserFromShopify = async (accessToken) => {
  try {
    const response = await networkRequest.get(`${API_URL}/user/currentUserFromShopify`, {
      idToken: accessToken,
    });
    return response;
  } catch (error) {
    return await Promise.reject(error);
  }
}


const getUserBasedOnRole = async (accessToken, role) => {
  try {
    const response = await networkRequest.get(`${API_URL}/user/filter?role=${role}`, {
      idToken: accessToken,
    });
    return response;
  } catch (error) {
    return await Promise.reject(error);
  }
}

export const userServices = { getAllUser, createUser, deleteUser, updateUser, getCurrentUser, getCurrentUserFromShopify, getUserBasedOnRole };
